export default __webpack_public_path__ + "static/media/1595.03163375.png";